// extracted by mini-css-extract-plugin
export default {"button":"BlackButton_button__LkTjv"};